import { useContext } from "react";

import { UserContext } from "Src/components/Context/UserContext";

export default function useUser() {
  const user = useContext(UserContext);

  return user;
}
